import React from 'react';

const propTypes = {

};

const defaultProps = {

};

function Privacy(props) {
    return (
        <div className="legal">
            <h1>Privacy Policy</h1>
            <p>
                This Privacy Policy governs the manner in which Muzzy Lane Software collects, uses, maintains and discloses information collected from users (each, a "User") of the https://author.muzzylane.com website ("Site"). This privacy policy applies to the Site and all products and services offered by Muzzy Lane Software.
            </p>
            <h2>Personal identification information</h2>
            <p>
                We may collect personal identification information from Users in a variety of ways, including, but not limited to, when Users visit our site, register on the site, place an order, and in connection with other activities, services, features or resources we make available on our Site. Users may be asked for, as appropriate, name, email address. Users may, however, visit our Site anonymously. We will collect personal identification information from Users only if they voluntarily submit such information to us. Users can always refuse to supply personally identification information, except that it may prevent them from engaging in certain Site related activities.
            </p>
            <h2>Non-personal identification information</h2>
            <p>
               We may collect non-personal identification information about Users whenever they interact with our Site. Non-personal identification information may include the browser name, the type of computer and technical information about Users means of connection to our Site, such as the operating system and the Internet service providers utilized and other similar information.
            </p>
            <h2>Web browser cookies</h2>
            <p>
                Our Site may use "cookies" to enhance User experience. User's web browser places cookies on their hard drive for record-keeping purposes and sometimes to track information about them. User may choose to set their web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.
            </p>
            <h2>How we use collected information</h2>
            <ul> Muzzy Lane Software may collect and use Users personal information for the following purposes:
                <li>
                    To run and operate our Site
                </li>
            </ul>
            <ul> We may need your information display content on the Site correctly.
                <li>
                    To improve customer service
                </li>
            </ul>
            <ul> Information you provide helps us respond to your customer service requests and support needs more efficiently.
                <li>
                    To personalize user experience
                </li>
            </ul>
            <ul> We may use information in the aggregate to understand how our Users as a group use the services and resources provided on our Site.
                <li>
                    To improve our Site
                </li>
            </ul>
            <ul> We may use feedback you provide to improve our products and services.
                <li>
                    To process payments
                </li>
            </ul>
            <ul> We may use the information Users provide about themselves when placing an order only to provide service to that order. We do not share this information with outside parties except to the extent necessary to provide the service.
                <li>
                    To send periodic emails
                </li>
            </ul>
            <p>
                We may use the email address to send User information and updates pertaining to their order. It may also be used to respond to their inquiries, questions, and/or other requests.
            </p>
            <h2>How we protect your information</h2>
            <p>
                We adopt appropriate data collection, storage and processing practices and security measures to protect against unauthorized access, alteration, disclosure or destruction of your personal information, username, password, transaction information and data stored on our Site.
            </p>
            <h2>Sharing your personal information</h2>
            <p>
                We do not sell, trade, or rent Users personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates and advertisers for the purposes outlined above. We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.
            </p>
            <h2>Electronic newsletters</h2>
            <p>
                If User decides to opt-in to our mailing list, they will receive emails that may include company news, updates, related product or service information, etc. If at any time the User would like to unsubscribe from receiving future emails, we include detailed unsubscribe instructions at the bottom of each email or User may contact us via our Site. We may use third party service providers to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys. We may share your information with these third parties for those limited purposes provided that you have given us your permission.
            </p>
            <h2>Changes to this privacy policy</h2>
            <p>
                Muzzy Lane Software has the discretion to update this privacy policy at any time. When we do, we will post a notification on the main page of our Site, revise the updated date at the bottom of this page. We encourage Users to frequently check this page for any changes to stay informed about how we are helping to protect the personal information we collect. You acknowledge and agree that it is your responsibility to review this privacy policy periodically and become aware of modifications.
            </p>
            <h2>Your acceptance of these terms</h2>
            <p>
                By using this Site, you signify your acceptance of this policy. If you do not agree to this policy, please do not use our Site. Your continued use of the Site following the posting of changes to this policy will be deemed your acceptance of those changes.
            </p>
            <h2>Contacting us</h2>
            <p>
                If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please <a href="https://www.muzzylane.com/contact-us/" target="_blank">contact us</a>.
            </p>
        </div>
    );
}

Privacy.propTypes = propTypes;
Privacy.defaultProps = defaultProps;

export default Privacy;